module.exports = __webpack_public_path__ + "img/mp.08e4708b.svg";